<template>
  <div>
    <messages messageType="inbox" />
  </div>
</template>

<script>
import Messages from '@/components/pages/Messages/Messages'

export default {
  name: 'received-messages',

  components: {'messages': Messages}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Messages/ReceivedMessages.vue